import { useCallback, useEffect, useState } from 'preact/hooks';

import { usePlayer } from './PlayerProvider';
import { usePlayerEvent } from './usePlayerEvent';

export function usePlayerFullscreen() {
  const player = usePlayer();
  const [isFullscreen, setIsFullscreen] = useState(
    player.getJWPlayer()?.getFullscreen() ?? false
  );

  const onChange = useCallback(() => {
    const jw = player.getJWPlayer();
    if (jw) {
      setIsFullscreen(jw.getFullscreen());
    }
  }, [player]);

  useEffect(() => {
    document.addEventListener('fullscreenchange', onChange);
    document.addEventListener('webkitfullscreenchange', onChange);

    return () => {
      document.removeEventListener('fullscreenchange', onChange);
      document.removeEventListener('webkitfullscreenchange', onChange);
    };
  }, [onChange]);

  usePlayerEvent('fullscreen', onChange);

  const toggleFullscreen = useCallback(() => {
    const jw = player.getJWPlayer();
    jw?.setFullscreen(!isFullscreen);
  }, [player, isFullscreen]);

  const exitFullscreen = useCallback(() => {
    const jw = player.getJWPlayer();
    jw?.setFullscreen(false);
  }, [player]);

  return { isFullscreen, toggleFullscreen, exitFullscreen };
}
